import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Stack, Package } from '@phosphor-icons/react';

const levelLetter = (i) => String.fromCharCode(65 + i);

export const previewCodes = (base, levels, depth) => {
  const b = (base || '').trim().toUpperCase();
  if (!b) return [];
  const out = [];
  for (let l = 0; l < levels; l += 1) {
    for (let d = 1; d <= depth; d += 1) out.push(`${b}${levelLetter(l)}${depth > 1 ? d : ''}`);
  }
  return out;
};

const SmallNum = ({ label, value, min, max, onChange, testid }) => (
  <div>
    <Label className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</Label>
    <Input
      type="number" min={min} max={max} value={value}
      onChange={(e) => onChange(Math.max(min, Math.min(max, Number(e.target.value) || min)))}
      className="mt-1 h-8 text-xs font-mono" data-testid={testid}
    />
  </div>
);

export const RackStructurePanel = ({ tile, onChange, onGenerate, onViewSkus, generating }) => {
  const levels = tile.levels || 1;
  const depth = tile.depth || 1;
  const base = tile.base_code ?? '';
  const codes = previewCodes(base, levels, depth);
  return (
    <div className="pt-3 border-t border-border space-y-2" data-testid="rack-structure-panel">
      <Label className="text-xs flex items-center gap-1"><Stack size={12} /> Rack structure</Label>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <Label className="text-[10px] uppercase tracking-widest text-muted-foreground">Base code</Label>
          <Input value={base} onChange={(e) => onChange({ base_code: e.target.value.toUpperCase() })} placeholder="A1" className="mt-1 h-8 text-xs font-mono" data-testid="rack-base-code-input" />
        </div>
        <SmallNum label="Levels" value={levels} min={1} max={26} onChange={(v) => onChange({ levels: v })} testid="rack-levels-input" />
        <SmallNum label="Deep" value={depth} min={1} max={9} onChange={(v) => onChange({ depth: v })} testid="rack-depth-input" />
      </div>
      <p className="text-[10px] font-mono text-muted-foreground" data-testid="rack-code-preview">
        {codes.length ? `${codes.slice(0, 6).join(', ')}${codes.length > 6 ? ` … ${codes[codes.length - 1]}` : ''} · ${codes.length} positions` : 'Enter a base code (e.g. A1) to preview location codes'}
      </p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={onGenerate} disabled={!codes.length || generating} data-testid="rack-generate-btn">
          {generating ? 'Creating…' : 'Create & link locations'}
        </Button>
        <Button size="sm" variant="outline" onClick={onViewSkus} disabled={!tile.location_ids?.length} data-testid="rack-view-skus-btn">
          <Package size={12} className="mr-1" /> View SKUs
        </Button>
      </div>
      <p className="text-[10px] text-muted-foreground">Higher levels and deeper positions count as slower in the simulator and optimiser.</p>
    </div>
  );
};
